<div class="panel panel-default">
  <div class="panel-heading flex flex--space-between">
    <h4 class="margin-top-0 margin-bottom-0 flex">
      <i class="icon margin-right-8">alert</i>{{ appCopy.panelHeader['issuesTitle'+selectedLanguage] }}
    </h4>
    <a class="link" href="javascript:void(0)" (click)="toggleAddIssueSection()">
      {{ !showAddIssue ? appCopy.panelHeader['addIssueButton'+selectedLanguage] : appCopy.panelHeader['hideText'+selectedLanguage] }}
    </a>
  </div>
  <div class="panel-body" *ngIf="!bookingIssuesLoaded">
    <div class="loader-container">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  </div>
  <div class="panel-body" *ngIf="bookingIssuesLoaded">
    <form *ngIf="showAddIssue"
      #formAddIssue="ngForm"
      class="margin-bottom-16"
      name="formAddIssue"
      (ngSubmit)="handleIssueSubmit(formAddIssue.value, $event)"
      novalidate>
      <div class="radio radio--default radio--small" *ngFor="let issue of bookingIssues; let i = index;">
        <input type="radio"
          name="bookingIssue"
          id="issue{{i}}"
          [(ngModel)]="bookingIssueSelected"
          [value]="i"
          required>
        <label for="issue{{i}}">{{ appCopy.panelHeader[issue+selectedLanguage] }}</label>
      </div>
      <button type="submit" class="btn btn-accent btn-block" [disabled]="formAddIssue.invalid || showAddIssueLoader">
        <div class="loader-container-btn" *ngIf="showAddIssueLoader">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        {{ appCopy.panelHeader['addButton'+selectedLanguage] }}
      </button>
    </form>
    <div *ngIf="noBookingIssues">
      <p>{{ appCopy.panelHeader['noBookingIssueText'+selectedLanguage] }}</p>
    </div>
    <div *ngIf="!noBookingIssues">
      <div *ngFor="let issue of issueArray; let last = last">
        <div class="note-item">
          <p class="margin-bottom-8"><strong>{{ issue.answer }}</strong></p>
          <p class="margin-bottom-0 clearfix">
            <span class="text-caption text-muted-light pull-left">
              {{ issue.user.firstName }} {{ issue.user.lastName }}<br>{{ issue.user.userRoles[0].description }}
            </span>
            <span class="text-caption text-muted-light pull-right">
              {{ issue.questionCreatedDateTime | amDateFormat: 'DD.MM.YY' }} |
              {{ issue.questionCreatedDateTime | amDateFormat: 'HH:mm' }}
            </span>
          </p>
        </div>
        <hr class="margin-top-16 margin-bottom-16" *ngIf="!last">
      </div>
    </div>
  </div>
</div>